import EditVirtualLineForm from "./edit_virtual_line_form";
import BaseVirtualLineModal from "./base_virtual_line_modal";

import Loading from "shared/loading";
import Ajax from "shared/ajax";

export default class EditVirtualLineModal extends BaseVirtualLineModal {
  get title() { return "Edit Promo Number"; }

  initialize(config) {
    super.initialize(config);
    this.config = config;
    this.model = this.config.model;

    this.successCallback = this.config.successCallback;
    this.form = new EditVirtualLineForm({ model: this.model, config: this.config });
  }

  buttons() {
    return [
      {
        text: "Cancel",
        className: "btn-secondary",
        close: true
      },
      {
        text: "Save",
        className: "btn-primary",
        click: this._onSave.bind(this)
      }
    ];
  }

  _onSave() {
    this.model.set("errors", []);
    this.render();
    this.configureLoadingMask();

    this.model.save({}, {
      url: this.config.editUrl,
      complete: Loading.hide,
      success: () => {
        this.onRequestSuccess("Successfully edited promo number.", this.model);
      },
      error: (model, xhr, options) => {
        this._setErrorAndRender(Ajax.errorMessages(xhr));
      }
    });
  }
}
